export default __webpack_public_path__ + "static/media/torusIcon.c9364e2e.svg";